module.exports = __webpack_public_path__ + "static/media/flag11.310fb643.svg";